"use strict";
// import { FluidKeyedObject } from "../../structs/internal";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DataLayerLogAll = exports.DataLayerLogType = void 0;
// export interface FluidAnalyticsInterface {
//   analyticsConfig: FluidDataLayerComponentConfiguration;
//   parentLayerId: string;
//   setupAnalytics: () => void;
// }
// export type FluidDataLayerSelector = (
//   layerState: FluidDataLayerState
// ) => FluidKeyedObject<any>;
// export type FluidDataLayerContext =
//   | FluidKeyedObject<any>
//   | FluidDataLayerSelector;
/**
 * Global configuration for the data layer - appId must be unique and is required,
 * globalContext can be a keyed object, or a selector function that returns one.
 */
// export interface FluidDataLayerConfiguration {
//   appId: string;
//   includeLogs?: DataLayerLogType[];
//   globalContext?: FluidDataLayerContext;
//   xhrMonitoring?: FluidDataLayerXHREventConfig;
// }
// export interface FluidDataLayerXHREventConfig {
//   info?: FluidXHRMonitorConfig;
//   success?: FluidXHRMonitorConfig;
//   redirect?: FluidXHRMonitorConfig;
//   clientError?: FluidXHRMonitorConfig;
//   serverError?: FluidXHRMonitorConfig;
// }
// export interface FluidXHRMonitorConfig {
//   alias: string;
//   stateMonitoring: FluidXHRStateMonitoringConfig[];
// }
// export interface FluidXHRStateMonitoringConfig {
//   url: string;
//   setStateAs: string;
// }
/**
 * Individual component configuration - this is how the FLUID components know
 * how and what to send to the data layer.
 */
// export interface FluidDataLayerComponentConfiguration {
//   appId: string;
//   identifier: string;
//   context?: FluidDataLayerContext;
//   trackEvents?: FluidKeyedObject<FluidDataLayerEventConfig>;
// }
// export interface FluidDataLayerEventConfig {
//   alias?: string;
//   context?: FluidDataLayerContext;
//   payload?: object;
// }
// export interface FluidDataLayerEvent {
//   identifier: string;
//   originatingAppId: string;
//   eventType: string;
//   payload: any;
//   timestamp?: Date;
// }
// export interface FluidDataLayerState {
//   previousPage?: FluidDataLayerPageData;
//   page?: FluidDataLayerPageData;
//   events?: FluidDataLayerEvent[];
//   previousEvent?: FluidDataLayerEvent;
//   currentEvent?: FluidDataLayerEvent;
//   user?: FluidDataLayerElement;
//   globalContext?: FluidKeyedObject<any>;
// }
var DataLayerLogType;
(function (DataLayerLogType) {
    DataLayerLogType["WINDOW_STATE_UPDATED"] = "window_state_updated";
    DataLayerLogType["GLOBAL_CONTEXT_UPDATED"] = "global_context_updated";
    DataLayerLogType["EVENT_PROPAGATED"] = "event_propagated";
    DataLayerLogType["EVENT_DISPATCHED"] = "event_dispatched";
    DataLayerLogType["EVENT_POSTED"] = "event_posted";
    DataLayerLogType["USER_DATA_UPDATED"] = "user_data_updated";
    DataLayerLogType["ROUTE_WATCHING_ACTIVE"] = "route_watching_active";
    DataLayerLogType["PAGE_DATA_UPDATED"] = "page_data_updated";
    DataLayerLogType["PAGE_TRANSITIONED"] = "page_transitioned";
    DataLayerLogType["LAYER_INITIALISED"] = "data_layer_initialised";
    DataLayerLogType["XHR_REQUEST_STARTED"] = "xhr_request_started";
    DataLayerLogType["XHR_MONITORING_ACTIVE"] = "xhr_monitoring_active";
})(DataLayerLogType = exports.DataLayerLogType || (exports.DataLayerLogType = {}));
// @ts-ignore
exports.DataLayerLogAll = Object.keys(DataLayerLogType).map((type) => DataLayerLogType[type]);
// export interface FluidDataLayerElement {
//   [key: string]: any;
// }
// export interface FluidDataLayerPageData {
//   pageName: string;
//   destinationURL?: string;
//   referringURL?: string;
//   sysEnv?: string;
//   geoRegion?: string;
//   appVersion?: string;
//   browser?: string;
//   timeOnPage?: number;
// }
